import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Input, Modal, ModalHeader, ModalBody } from 'reactstrap';

import { connect } from 'react-redux';
import { ISuperAdminContainer, ISuperAdminReduxProps } from '../../types/interfaces';
import { getUsers } from '../../flux/actions/userActions';
import { getVenteByIdPromise, undoDesistementClient, undoDesistementEncaissement, undoDesistementGroup, deleteVentePromise, editComVentePromise, getCustomizedVentePromise, venteAssToUniquePromise } from '../../flux/actions/venteActions';
import { deleteAssociationPromise, editComPartPromise } from '../../flux/actions/associationActions';
import { deleteEncaissementPromise, editComEncaissementPromise } from '../../flux/actions/encaissementActions';
import { verifyInactifEnc, correctCommissions } from '../../flux/actions/commissionhistoryActions';
import { cancelCommissionBulletin, mergeCommissionBulletins } from '../../flux/actions/commissionbulletinActions';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faBoxOpen, faUsers, faSearch, faBell, faExclamation, faInfo, faSearchPlus, faExclamationTriangle, faFilePdf, faCommentsDollar, faEdit, faSpinner, faCalculator, faTrash, faFileSignature, faUser, faFileInvoice } from '@fortawesome/free-solid-svg-icons'
import PDFLink, { b64toBlob, InstantPreview } from '../pdf/PDFLink';
import { replaceEncaissement } from '../../flux/actions/encaissementActions';
import { getConstanteProjetInfos } from '../../flux/actions/constanteActions';
import { useAlert } from "react-alert";
import { PRIVILEGE } from '../../types/privileges';
// import { Bar } from 'react-chartjs-2';

const SuperAdminContainerComponent = ({
  getUsers,
  user,
  auth
}: ISuperAdminContainer) => {
  const alert = useAlert();
  const { users, loading: loadingU } = user;
  const userOptions = (auth?.user?.privileges?.includes(PRIVILEGE.OTHERS_COMMISSIONS) ? [{id: "ALL", LOGIN: "Tous les commerciaux"}, ...users.map(e => ({id: e.id, LOGIN: e.username}))] : [{id: auth?.user?.id, LOGIN: auth?.user?.username}]).map(e => ({value: e.id, label: e["LOGIN"] || e["username"], user: e}));
  const [selectedUser, setSelectedUser] = useState<any>(/*userOptions.find(e => e.value === "ALL")?.user || */'');
  const [recuContratId, setRecuContratId] = useState(undefined);
  const [recuRecuImageId, setRecuRecuImageId] = useState(undefined);
  const [encaissementsIds, setEncaissementsIds] = useState('');
  const [clientsIds, setClientsIds] = useState('');
  const [assId, setAssId] = useState(undefined);
  const [recuModal, setRecuModal] = useState(false);
  const [recuData, setRecuData] = useState<any>(undefined);
  const chartRef = React.useRef<any>(document.createElement("canvas"));
  const [modalCorrect, setModalCorrect] = useState(false);
  const [disableSubmitCorrect, setDisableSubmitCorrect] = useState(false);
  const [reEnableCorrect, setReEnableCorrect] = useState(false);
  
  const [bulletinId, setBulletinId] = useState('');
  const [mergeBulletinsIds, setMergeBulletinsIds] = useState('');

  const [delVenteId, setDelVenteId] = useState('');
  const [delPartId, setDelPartId] = useState('');
  const [delEncaissementId, setDelEncaissementId] = useState('');
  
  const [assToUniqueVenteId, setAssToUniqueVenteId] = useState('');
  
  const [comVenteId, setComVenteId] = useState('');
  const [comPartId, setComPartId] = useState('');
  const [comEncaissementId, setComEncaissementId] = useState('');
  const [comCom, setComCom] = useState<any>('');
  
  const [customizedVenteDesistementId, setCustomizedVenteDesistementId] = useState('');
  const [customizedPartDesistementId, setCustomizedPartDesistementId] = useState('');

  const handleToggleCorrect = () => setModalCorrect(!modalCorrect);
  
  // const [replacerEncaissementId, setReplacerEncaissementId] = useState('');
  // const [encaissementsSortisIds, setEncaissementsSortisIds] = useState('');
  // const [isReplacing, setIsReplacing] = useState(false);

  const [desistementClientId, setDesistementClientId] = useState('');
  const [desistementEncaissementId, setDesistementEncaissementId] = useState('');
  const [desistementId, setDesistementId] = useState('');
  
  const recuContratIdChangeHandle = e => setRecuContratId(e.target.value.trim());
  const recuRecuImageIdChangeHandle = e => setRecuRecuImageId(e.target.value.trim());
  const encaissementsIdsChangeHandle = e => setEncaissementsIds(e.target.value.trim());
  const clientsIdsChangeHandle = e => setClientsIds(e.target.value.trim());
  const assIdChangeHandle = e => setAssId(e.target.value.trim());
  const bulletinIdChangeHandle = e => setBulletinId(e.target.value.trim());
  const mergeBulletinsIdsChangeHandle = e => setMergeBulletinsIds(e.target.value.trim());
  const delVenteIdChangeHandle = e => setDelVenteId(e.target.value.trim());
  const delPartIdChangeHandle = e => setDelPartId(e.target.value.trim());
  const delEncaissementIdChangeHandle = e => setDelEncaissementId(e.target.value.trim());
  
  const comVenteIdChangeHandle = e => setComVenteId(e.target.value.trim());
  const comPartIdChangeHandle = e => setComPartId(e.target.value.trim());
  const comEncaissementIdChangeHandle = e => setComEncaissementId(e.target.value.trim());

  // const replacerEncaissementIdChangeHandle = e => setReplacerEncaissementId(e.target.value.trim());
  // const encaissementsSortisIdsChangeHandle = e => setEncaissementsSortisIds(e.target.value.trim());

  const desistementClientIdChangeHandle = e => setDesistementClientId(e.target.value.trim());
  const desistementEncaissementIdChangeHandle = e => setDesistementEncaissementId(e.target.value.trim());
  const desistementIdChangeHandle = e => setDesistementId(e.target.value.trim());

  useEffect(() => getUsers(), [getUsers])

  const handleUserChange = data => {
    setSelectedUser(data ? data.user : '');
  }

  const handleComComChange = data => {
    setComCom(data ? data.user : '');
  }

  const modalClosedHandleCorrect = () => {
    if(reEnableCorrect){
      setDisableSubmitCorrect(false);
      setReEnableCorrect(false);
    }
  };

  const callbackCorrect = (success) => {
    console.log("cb", success)
    if(success?.success){
      setReEnableCorrect(true);
      setModalCorrect(false);
      alert.success("Commissions corrigées avec succès");
      return
    }
    alert.error("Une erreur s'est produite");
    setDisableSubmitCorrect(false);
  }

  const correctCommissionsHandle = async () => {
    if(!selectedUser)
      return
    setDisableSubmitCorrect(true);
    const res = await correctCommissions(selectedUser?.id, auth?.user?.id);
    callbackCorrect(res?.data)
  };

  return (
    <>
      <Container>
        <Row className="justify-content-between">
          <h2 className="title"><FontAwesomeIcon icon={faFilePdf} />&nbsp;&nbsp;Génération Reçus</h2>
        </Row>
        <Row>
          <Col xs="6" sm="3">
            <Input type="text" placeholder="ID CONTRAT..." value={recuContratId} onChange={recuContratIdChangeHandle} />
            <FontAwesomeIcon icon={faSearchPlus} style={{position: "absolute", top: "10px", right: "-4px", cursor: "pointer"}} title="log contrat data" onClick={() => {
              if(!recuContratId)
                return
              getVenteByIdPromise(recuContratId || -1).then(e => console.log("CONTRAT", e))
            }} />
          </Col>
          <Col xs="6" sm="3">
            <Input type="text" placeholder="ID RECU..." value={recuRecuImageId} onChange={recuRecuImageIdChangeHandle} />
          </Col>
          <Col xs="6" sm="3">
            <Input type="text" placeholder="IDs contrat_encaissements 7542,8542,9653" value={encaissementsIds} onChange={encaissementsIdsChangeHandle} />
          </Col>
          <Col xs="6" sm="3">
            <Input type="text" placeholder="IDs contrat_clients 8542,4562" value={clientsIds} onChange={clientsIdsChangeHandle} />
          </Col>
          <Col xs="6" sm="3">
            <Input type="text" placeholder="ID ASS" value={assId} onChange={assIdChangeHandle} />
          </Col>
        </Row>
        <Row className="justify-content-center">
            <Button
              color="info"
              onClick={async () => {
                if(!recuContratId || !recuRecuImageId)
                  return
                if(clientsIds.includes(" ") || encaissementsIds.includes(" ")){
                  alert("Remove spaces from Ids field..")
                  return
                }
                const contratData = await getVenteByIdPromise(recuContratId || -1);
                console.log("cc", contratData)
                if(!contratData)
                  return
                const constantesProjet = await getConstanteProjetInfos(contratData.IDPROJET || -1, contratData.PROJET || "");
                const recuImage = contratData.recu_images?.find(e => e.id == recuRecuImageId);
                const addedContratClients = (clientsIds ? contratData.contrat_clients.filter(e => e.id && clientsIds.split(",").includes(e.id.toString())) : contratData.contrat_clients.filter(e => !assId || e.ID_ASS == assId)).map(e => e.client).filter((value, index, self) => value?.id === undefined || self.findIndex(e => e?.id === value?.id) === index);
                const contrat_clients = clientsIds ? contratData.contrat_clients.filter(e => e.id && clientsIds.split(",").includes(e.id.toString())) : contratData.contrat_clients;
                const addedContratEnc = encaissementsIds ? contratData.contrat_encaissements.filter(e => e.id && encaissementsIds.split(",").includes(e.id.toString())).map(e => ({...e, ...e.encaissement})) : contratData.contrat_encaissements.filter(e => e.enc_supp).map(e => ({...e, ...e.encaissement}));
                const contrat_encaissements = encaissementsIds ? contratData.contrat_encaissements.filter(e => e.id && encaissementsIds.split(",").includes(e.id.toString())) : contratData.contrat_encaissements.filter(e => !assId || e.ID_ASS == assId);
                // const chartt = chartRef.current.toBase64Image();
                // const versoFtpCheckBlob = b64toBlob(chartt.replace('data:image/png;base64,', ''), 'image/png')
                // const chartUrl = URL.createObjectURL(versoFtpCheckBlob);
                setRecuData({...contratData, contrat_clients, contrat_encaissements, constantesProjet, recu_image_counter: recuImage?.recu_image_counter, enc: recuImage?.enc_supp, specificDate: recuImage?.createdAt, addedContratClients, addedContratEnc, /*association: !!recuImage?.association,*/ associationId: assId ? Number(assId) : undefined/*, isNewAssociation: assId && !recuImage?.enc_supp*/, authUserId: contratData.ID_COM})
                setRecuModal(true)
              }}>Générer</Button>
        </Row>
        {/* <Row className="justify-content-between">
          <h2 className="title"><FontAwesomeIcon icon={faCommentsDollar} />&nbsp;&nbsp;Remplacements Chèques</h2>
        </Row>
        <Row className="justify-content-center">
          <Col xs="6" sm="6">
            <Input type="text" placeholder="ID contrat_encaissement (nouveau)..." value={replacerEncaissementId} onChange={replacerEncaissementIdChangeHandle} />
          </Col>
          <Col xs="6" sm="6">
            <Input type="text" placeholder="IDs contrat_encaissements 7542,8542,9653 (Anciens)" value={encaissementsSortisIds} onChange={encaissementsSortisIdsChangeHandle} />
          </Col>
        </Row>
        <Row className="justify-content-center">
            <Button
              color="warning"
              disabled={isReplacing}
              onClick={async () => {
                if(!replacerEncaissementId)
                  return
                if(encaissementsSortisIds.includes(" ")){
                  alert("Remove spaces from Ids field..")
                  return
                }
                setIsReplacing(true);
                const res = await replaceEncaissement(Number(replacerEncaissementId), encaissementsSortisIds.split(",").map(e => Number(e)), auth?.user && auth?.user.id ? auth?.user.id : undefined, auth?.user && auth?.user.username ? auth?.user.username : undefined);
                if(res?.success){
                  setReplacerEncaissementId('');
                  setEncaissementsSortisIds('');
                  alert.success("Encaissement remplacé avec succès")
                }
                else
                  alert.error("Error")
                setIsReplacing(false);
              }}>Remplacer</Button>
        </Row> */}

        {/* <Row className="justify-content-between">
          <h2 className="title"><FontAwesomeIcon icon={faEdit} />&nbsp;&nbsp;Correction commissions non validées</h2>
        </Row>
        <Row className="justify-content-center">
            <Button
              color="warning"
              onClick={() => setModalCorrect(true)}>Recalculer</Button>
            <Button
              color="danger"
              onClick={async () => {
                const res = await commTest()
                console.log("comm", res)
              }}>AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA</Button>
        </Row> */}
        <Row className="justify-content-between">
          <h2 className="title"><FontAwesomeIcon icon={faEdit} />&nbsp;&nbsp;Générer commission Malus</h2>
        </Row>
        <Row className="justify-content-center">
            <Button
              color="danger"
              onClick={async () => {
                if(!confirm("Voulez-vous continuer ?"))
                  return
                const res = await verifyInactifEnc()
                console.log("verifyInactifEnc", res)
              }}>Générer</Button>
        </Row>
        <Row className="justify-content-between">
          <h2 className="title"><FontAwesomeIcon icon={faExclamationTriangle} />&nbsp;&nbsp;Annulation Désistement (attention commission + statut enc!)</h2>
        </Row>
        <Row className="mb-1">
          <Col xs="6">
            <Input type="text" placeholder="ID DESISTEMENT (Client)..." value={desistementClientId} onChange={desistementClientIdChangeHandle} />
          </Col>
          <Col xs="6">
            <Button
              color="danger"
              onClick={async () => {
                if(!desistementClientId)
                  return
                if(desistementClientId.includes(" ")){
                  alert("Remove spaces from Id field..")
                  return
                }
                const res = await undoDesistementClient(Number(desistementClientId));
                if(res)
                  alert.success("done")
                else
                  alert.error("Error, check out the console logs")
              }}>Ressaisir le CLIENT</Button>
          </Col>
        </Row>
        <Row className="mb-1">
          <Col xs="6">
            <Input type="text" placeholder="ID DESISTEMENT (encaissement)..." value={desistementEncaissementId} onChange={desistementEncaissementIdChangeHandle} />
          </Col>
          <Col xs="6">
            <Button
              color="danger"
              onClick={async () => {
                if(!desistementEncaissementId)
                  return
                if(desistementEncaissementId.includes(" ")){
                  alert("Remove spaces from Id field..")
                  return
                }
                const res = await undoDesistementEncaissement(Number(desistementEncaissementId));
                if(res)
                  alert.success("done")
                else
                  alert.error("Error, check out the console logs")
              }}>Ressaisir l'ENCAISSEMENT</Button>
          </Col>
        </Row>
        <Row>
          <Col xs="6">
            <Input type="text" placeholder="ID DESISTEMENT..." value={desistementId} onChange={desistementIdChangeHandle} />
          </Col>
          <Col xs="6">
            <Button
              color="danger"
              onClick={async () => {
                if(!desistementId)
                  return
                if(desistementId.includes(" ")){
                  alert("Remove spaces from Id field..")
                  return
                }
                const res = await undoDesistementGroup(Number(desistementId));
                if(res)
                  alert.success("done")
                else
                  alert.error("Error, check out the console logs")
              }}>Ressaisir les CLIENTS / ENCAISSEMENTS</Button>
          </Col>
        </Row>
        {/* <Row>
        <Bar data={{
          labels: ['k', 'm'],
          datasets: [
            {
              label: 'Toooooo',
              data: [7,2],
              backgroundColor: 'cornflowerblue',
            },
            {
              label: 'Toooooo2',
              data: [3,9],
              backgroundColor: 'red',
            },
          ],
        }} options={{
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
          animation: {
            duration: 0
          }
        }} ref={chartRef} />
        </Row> */}
        <Row className="justify-content-between">
          <h2 className="title"><FontAwesomeIcon icon={faCalculator} />&nbsp;&nbsp;Générer Fiche Vente</h2>
        </Row>
        <Row>
          <Col xs="6">
            <Input type="text" placeholder="ID DESISTEMENT..." value={customizedVenteDesistementId} onChange={e => setCustomizedVenteDesistementId(e.target.value.trim())} />
          </Col>
          <Col xs="6">
            <PDFLink documentType={"vente"}
              func={async () => getCustomizedVentePromise(customizedVenteDesistementId)}
              download={false}
              buttonText=""
              iconSize="inherit"
              // customClassNames="btn btn-info"
              customButtonIcon={faFileInvoice}
              allowPrintPreview={true}
              htmlTitle={`Générer la fiche de Vente`}
              customClassNames="btn btn-success btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
              style={{paddingRight: ".75rem", paddingLeft: ".75rem"}} />
          </Col>
        </Row>
        <Row>
          <Col xs="6">
            <Input type="text" placeholder="FICHE PART --- ID DESISTEMENT..." value={customizedPartDesistementId} onChange={e => setCustomizedPartDesistementId(e.target.value.trim())} />
          </Col>
          <Col xs="6">
            <PDFLink documentType={"part"}
              func={async () => getCustomizedVentePromise(customizedPartDesistementId, 1)}
              download={false}
              buttonText=""
              iconSize="inherit"
              // customClassNames="btn btn-info"
              customButtonIcon={faFileInvoice}
              allowPrintPreview={true}
              htmlTitle={`Générer la fiche de Part`}
              customClassNames="btn btn-warning btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
              style={{paddingRight: ".75rem", paddingLeft: ".75rem"}} />
          </Col>
        </Row>
        <Row className="justify-content-between">
          <h2 className="title"><FontAwesomeIcon icon={faCalculator} />&nbsp;&nbsp;Annulation Bulletin Commission</h2>
        </Row>
        <Row>
          <Col xs="6">
            <Input type="text" placeholder="ID BULLETIN..." value={bulletinId} onChange={bulletinIdChangeHandle} />
          </Col>
          <Col xs="6">
            <Button
              color="danger"
              onClick={async () => {
                if(!bulletinId)
                  return
                if(bulletinId.includes(" ")){
                  alert("Remove spaces from Id field..")
                  return
                }
                const res = await cancelCommissionBulletin(Number(bulletinId));
                if(res)
                  alert.success("done")
                else
                  alert.error("Error, check out the console logs")
              }}>Supprimer bulletin</Button>
          </Col>
        </Row>
        <Row>
          <Col xs="6">
            <Input type="text" placeholder="IDs bulletins 205,216" value={mergeBulletinsIds} onChange={mergeBulletinsIdsChangeHandle} />
          </Col>
          <Col xs="6">
            <Button
              color="warning"
              onClick={async () => {
                if(!mergeBulletinsIds)
                  return
                if(mergeBulletinsIds.includes(" ")){
                  alert("Remove spaces from Ids field..")
                  return
                }
                const res = await mergeCommissionBulletins(mergeBulletinsIds.split(",").map(e => Number(e)));
                if(res)
                  alert.success("done")
                else
                  alert.error("Error, check out the console logs")
              }}>Fusionner les bulletins</Button>
          </Col>
        </Row>
        <Row className="justify-content-between">
          <h2 className="title"><FontAwesomeIcon icon={faFileSignature} />&nbsp;&nbsp;Annulation Vente</h2>
        </Row>
        <Row>
          <Col xs="6">
            <Input type="text" placeholder="ID VENTE" value={delVenteId} onChange={delVenteIdChangeHandle} />
          </Col>
          <Col xs="6">
            <Button
              color="danger"
              onClick={async () => {
                if(!delVenteId)
                  return
                const res = await deleteVentePromise(Number(delVenteId));
                if(res)
                  alert.success("done")
                else
                  alert.error("Error, check out the console logs")
              }}>Supprimer la vente</Button>
          </Col>
        </Row>
        <Row>
          <Col xs="6">
            <Input type="text" placeholder="ID PART" value={delPartId} onChange={delPartIdChangeHandle} />
          </Col>
          <Col xs="6">
            <Button
              color="danger"
              onClick={async () => {
                if(!delPartId)
                  return
                const res = await deleteAssociationPromise(Number(delPartId));
                if(res)
                  alert.success("done")
                else
                  alert.error("Error, check out the console logs")
              }}>Supprimer la part</Button>
          </Col>
        </Row>
        <Row>
          <Col xs="6">
            <Input type="text" placeholder="ID ENCAISSEMENT" value={delEncaissementId} onChange={delEncaissementIdChangeHandle} />
          </Col>
          <Col xs="6">
            <Button
              color="danger"
              onClick={async () => {
                if(!delEncaissementId)
                  return
                const res = await deleteEncaissementPromise(Number(delEncaissementId));
                if(res)
                  alert.success("done")
                else
                  alert.error("Error, check out the console logs")
              }}>Supprimer l'encaissement</Button>
          </Col>
        </Row>

        <Row className="justify-content-between">
          <h2 className="title"><FontAwesomeIcon icon={faFileSignature} />&nbsp;&nbsp;Changer Asso en Unique</h2>
        </Row>
        <Row>
          <Col xs="6">
            <Input type="text" placeholder="ID VENTE" value={assToUniqueVenteId} onChange={e => setAssToUniqueVenteId(e.target.value.trim())} />
          </Col>
          <Col xs="6">
            <Button
              color="warning"
              onClick={async () => {
                if(!assToUniqueVenteId)
                  return
                const res = await venteAssToUniquePromise(Number(assToUniqueVenteId));
                if(res)
                  alert.success("done")
                else
                  alert.error("Error, check out the console logs")
              }}>Modifier en unique</Button>
          </Col>
        </Row>
        
        <Row className="justify-content-between">
          <h2 className="title"><FontAwesomeIcon icon={faUser} />&nbsp;&nbsp;Changer Commercial</h2>
        </Row>
        <Row>
          <Col xs="4">
            <Input type="text" placeholder="ID VENTE" value={comVenteId} onChange={comVenteIdChangeHandle} />
          </Col>
          <Col xs="4">
            <Select
              name="user"
              className="reactselect"
              classNamePrefix="react-select"
              value={comCom ? {label: comCom["LOGIN"] || comCom["username"], value: comCom.id, user: comCom} : null}
              onChange={handleComComChange}
              placeholder={'Chercher par nom...'}
              isClearable={false}
              isLoading={loadingU}
              loadingMessage={() => 'Chargement...'}
              noOptionsMessage={() => 'pas de resultat'}
              isSearchable={true}
              // labelKey='LOGIN'
              // valueKey='countryCode'
              options={userOptions}
            />
          </Col>
          <Col xs="4">
            <Button
              color="danger"
              onClick={async () => {
                if(!comVenteId || !comCom)
                  return
                const res = await editComVentePromise(Number(comVenteId), Number(comCom.id));
                if(res)
                  alert.success("done")
                else
                  alert.error("Error, check out the console logs")
              }}>Modifier le commercial de la vente</Button>
          </Col>
        </Row>
        <Row>
          <Col xs="4">
            <Input type="text" placeholder="ID PART" value={comPartId} onChange={comPartIdChangeHandle} />
          </Col>
          <Col xs="4">
            <Select
              name="user"
              className="reactselect"
              classNamePrefix="react-select"
              value={comCom ? {label: comCom["LOGIN"] || comCom["username"], value: comCom.id, user: comCom} : null}
              onChange={handleComComChange}
              placeholder={'Chercher par nom...'}
              isClearable={false}
              isLoading={loadingU}
              loadingMessage={() => 'Chargement...'}
              noOptionsMessage={() => 'pas de resultat'}
              isSearchable={true}
              // labelKey='LOGIN'
              // valueKey='countryCode'
              options={userOptions}
            />
          </Col>
          <Col xs="4">
            <Button
              color="danger"
              onClick={async () => {
                if(!comPartId || !comCom)
                  return
                const res = await editComPartPromise(Number(comPartId), Number(comCom.id));
                if(res)
                  alert.success("done")
                else
                  alert.error("Error, check out the console logs")
              }}>Modifier le commercial de la part</Button>
          </Col>
        </Row>
        <Row>
          <Col xs="4">
            <Input type="text" placeholder="ID ENCAISSEMENT" value={comEncaissementId} onChange={comEncaissementIdChangeHandle} />
          </Col>
          <Col xs="4">
            <Select
              name="user"
              className="reactselect"
              classNamePrefix="react-select"
              value={comCom ? {label: comCom["LOGIN"] || comCom["username"], value: comCom.id, user: comCom} : null}
              onChange={handleComComChange}
              placeholder={'Chercher par nom...'}
              isClearable={false}
              isLoading={loadingU}
              loadingMessage={() => 'Chargement...'}
              noOptionsMessage={() => 'pas de resultat'}
              isSearchable={true}
              // labelKey='LOGIN'
              // valueKey='countryCode'
              options={userOptions}
            />
          </Col>
          <Col xs="4">
            <Button
              color="danger"
              onClick={async () => {
                if(!comEncaissementId || !comCom)
                  return
                const res = await editComEncaissementPromise(Number(comEncaissementId), Number(comCom.id));
                if(res)
                  alert.success("done")
                else
                  alert.error("Error, check out the console logs")
              }}>Modifier le commercial de l'encaissement</Button>
          </Col>
        </Row>
      </Container>
      <Modal isOpen={modalCorrect} toggle={handleToggleCorrect} onClosed={modalClosedHandleCorrect}>
        <ModalHeader toggle={handleToggleCorrect}><FontAwesomeIcon icon={faEdit} />&nbsp;&nbsp;Correction des commissions non validées</ModalHeader>
        <ModalBody>
            <Container className="linesConfirmationContainer">
              <Row>
                <Col xs="12">
                  Voulez-vous vraiment correctionner les commissions de&nbsp;:
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <Select
                    name="user"
                    className="reactselect"
                    classNamePrefix="react-select"
                    value={selectedUser ? {label: selectedUser["LOGIN"] || selectedUser["username"], value: selectedUser.id, user: selectedUser} : null}
                    onChange={handleUserChange}
                    placeholder={'Chercher par nom...'}
                    isClearable={false}
                    isLoading={loadingU}
                    loadingMessage={() => 'Chargement...'}
                    noOptionsMessage={() => 'pas de resultat'}
                    isSearchable={true}
                    // labelKey='LOGIN'
                    // valueKey='countryCode'
                    options={userOptions}
                  />
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Button
                  className="btn btn-danger linesConfirmationBtn linesDeleteBtn"
                  onClick={correctCommissionsHandle}
                  disabled={disableSubmitCorrect}
                  ><FontAwesomeIcon icon={disableSubmitCorrect ? faSpinner : faEdit} className={disableSubmitCorrect ? "spinner" : ""} />&nbsp;&nbsp;Recalculer</Button>
              </Row>
            </Container>
        </ModalBody>
      </Modal>
      <InstantPreview
        documentType="recu"
        fileName={`recu__${recuRecuImageId}__${recuContratId}`}
        data={recuData}
        modal={recuModal}
        setModal={setRecuModal}
        showPreviewWatermark={false} />
    </>
  );
};

const mapStateToProps = (state: ISuperAdminReduxProps) => ({
  user: state.user,
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, { getUsers })(SuperAdminContainerComponent);
